module.exports = __webpack_public_path__ + "img/background.ee590ea3.png";